// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1666e52c","239":"ad40150f","455":"b91e6987","557":"5d4a5d48","762":"7f468c4e"}[chunkId] + ".chunk.js";
};